import React from 'react';
import PropTypes from 'prop-types';
import S from '../../../styles/components';

class TrackGroup extends React.PureComponent {
  static propTypes = {
    label: PropTypes.string,
  };

  static defaultProps = {
    label: '',
  };

  render() {
    const { label, children } = this.props;

    return (
      <S.TrackGroup>
        {label
          ? (
            <S.Track>
              <S.TrackGroupLabel>{label}</S.TrackGroupLabel>
              <th></th>
            </S.Track>
          ) : null
        }
        {children}
      </S.TrackGroup>
    );
  }
}
export default TrackGroup;
